import { render, staticRenderFns } from "./MarkText.vue?vue&type=template&id=020302b8&scoped=true&"
import script from "./MarkText.vue?vue&type=script&lang=js&"
export * from "./MarkText.vue?vue&type=script&lang=js&"
import style0 from "./MarkText.vue?vue&type=style&index=0&id=020302b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020302b8",
  null
  
)

export default component.exports